<template>
  <me-combo-tree v-bind="$props" v-on="$listeners" :data="comboData" />
</template>
<script>
import { Assert } from 'me-view/lib/script/index'
import http from '@common/ExtendHttp'
import comboMixin from '../mixins/combo.mixin'
export default {
  mixins: [ comboMixin ],
  name: 'ComboTreeCommon',
  props: {
    pathName: String,
    eventName: String,
    parameter: Object
  },
  data () {
    return {
      comboData: []
    }
  },
  created () {
    Assert.notBlank(this.eventName, 'props 属性 event-name 不能为空')
    this.$eventMonitor.register(this.eventName, data => {
      Assert.notBlank(this.pathName, 'props 属性 path-name 不能为空')
      console.debug(`ComboTreeCommon --> dispatch event=${this.eventName}, url=${this.pathName}, param=`, data)
      http.get(this.pathName, data || {}).then(data => {
        this.comboData = data || [ ]
      })
    })
    this.$eventMonitor.dispatch(this.eventName, this.parameter || {})
  }
}
</script>
